<template>
  <button
    v-if="isVisible"
    @click="openModal()"
    class="btn btn-primary btn-sm t-600 py-1 px-3 ml-2"
    :style="{ marginTop: '-4px', marginBottom: '-4px'}"
    type="button"><i class="fa fa-mail-forward pr-2"
  />Export<i class="fa fa-lock semi-transparent ml-2" v-if="!canExport" /></button>
</template>

<script>
export default {
  name: 'exportCSV',
  props: {
    isScopedSearch: {
      type: Boolean,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    isVisible () {
      return this.count > 0 && // Needs more than 1 record to be exported
        this.showForCategories(this.index) // Only show for these categories
    },
    canExport () {
      return this.$can('export')
    }
  },
  methods: {
    openModal () {
      this.$events.$emit('modal:export_csv', {
        count: this.count,
        scope: this.index,
        state: this.state
      })
    },
    showForCategories (category) {
      let categories = ['research_groups', 'researchers', 'publications', 'projects', 'research_topics', 'clinical_trials', 'patents', 'organisations', 'news']
      return categories.includes(category)
    }
  }
}
</script>
